import { ElementRef, Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as xlsx from 'xlsx';
import { Workbook } from 'exceljs';
import { DynamicTableColumnModel } from '../../models/dto/core/dynamicTableColumn.model';
import { ExportExcelRequestModel } from '../../models/dto/core/export-excel-request.model';
import { ExcelConstant } from '../../constant/excel.constant';
import { DateFormatEnum } from '../../enum/date-format.enum';
import { TranslateService } from '@ngx-translate/core';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {


  constructor(private translate: TranslateService
  ) { }


  exportExcelWithTable(request: ExportExcelRequestModel) {
    if (!request.fileName) {
      throw new Error('Filename not found');
    }

    request.columns = request.columns.filter(x => (x.isExportExcel || x.isExportExcel == null));

    // console.log('fileName:' + fileName);
    let workbook = new Workbook();

    let worksheet = workbook.addWorksheet(request.fileName, {
      properties: {
        tabColor: { argb: 'FF00FF00' },
        defaultColWidth: ExcelConstant.DEFAULT_WIDTH,
        defaultRowHeight: 30
      }
    });

    // worksheet.views = [
    //   { state: 'frozen', xSplit: 2, ySplit: 3, topLeftCell: 'G10', activeCell: 'A1' }
    // ];

    let rows: any[] = [];
    let tableColumns: any[] = [];
    let hasTotalRows = false;
    let hasMerge = false;

    let colIndex = 0;
    request.columns.forEach(c => {
      colIndex++;
      tableColumns.push({
        name: c.header,
        totalsRowLabel: 'Totals:',
        totalsRowFunction: c.totalsRowFunction,
        filterButton: true
      });

      if (c.excelWidth)
        worksheet.getColumn(colIndex).width = c.excelWidth;
      if (c.totalsRowFunction)
        hasTotalRows = true;
      if (c.isMerge)
        hasMerge = true;
    });

    request.data.forEach(e => {
      let cols = [];

      request.columns.forEach(c => {

        if (c.dateFormat && e[c.field])
          cols.push(new Date(e[c.field]).toLocaleString());
        else if (c.translateKey) {
          if (e[c.field] != undefined)
            cols.push(this.translate.instant(c.translateKey + "." + e[c.field]));
          else
            cols.push("");
        }
        else if (c.dataType == 'decimal')
          cols.push(Number(e[c.field]).toFixed(c.roundDecimal ?? 2));
        else if (c.dataType == 'boolean')
          cols.push(this.translate.instant('boolean.' + e[c.field]));
        else
          cols.push(e[c.field]);
      });

      rows.push(cols);
    });

    if (hasTotalRows && request.addTotalRows) {
      let cols = [];
      colIndex = 0;
      request.columns.forEach(c => {
        colIndex++;
        if (colIndex == 1 && !c.totalsRowFunction)
          cols.push(this.translate.instant('common.total'));
        else if (c.totalsRowFunction && c.totalsRowFunction == 'sum')
          cols.push(request.data.reduce((sum, item) => sum + (item[c.field] || 0), 0));
        else if (c.totalsRowFunction && c.totalsRowFunction == 'count')
          cols.push(request.data.length);
        else
          cols.push('');

      });

      rows.push(cols);

    }

    if (hasMerge) {
      let startRowIndex = 1;
      let endRowIndex = 1;
      let counter = -1;
      let rowsCount = rows.length;
      let lastValue;

      rows.forEach(x => {
        counter++;


        if (counter == 0) {
          startRowIndex = 2;
          lastValue = rows[counter][0];
        }
        else if (counter < rowsCount && lastValue != rows[counter][0]) {
          lastValue = rows[counter][0];
          endRowIndex = counter + 1;

          colIndex = 0;
          request.columns.forEach(c => {
            colIndex++;
            if (c.isMerge)
              worksheet.mergeCells(startRowIndex, colIndex, endRowIndex, colIndex);
          });

          startRowIndex = endRowIndex + 1;
        }
        else if (counter + 1 == rowsCount) {
          endRowIndex = counter + 2;
          colIndex = 0;

          request.columns.forEach(c => {
            colIndex++;
            if (c.isMerge)
              worksheet.mergeCells(startRowIndex, colIndex, endRowIndex, colIndex);
          });
        }
      });
    }



    // worksheet.autoFilter = {
    //   from: {
    //     row: 1,
    //     column: 1
    //   },
    //   to: {
    //     row: 1,
    //     column: tableColumns.length
    //   }
    // }

    worksheet.addTable({
      name: 'Data',
      ref: 'A1',
      headerRow: true,
      totalsRow: false,
      style: {
        // theme: 'TableStyleDark3',
        showRowStripes: true,
      },
      columns: tableColumns,
      rows: rows,
    });

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, request.fileName.replace(' ', '_') + '_' + new Date().toISOString() + EXCEL_EXTENSION);
    })

  }

  // Ekranda gösterilen alanlardan excele aktarılacakların belirlenmesi
  // exportExcelWithDynamicColumns(data: any[], fileName: string, columns: DynamicTableColumnModel[]) {

  //   if (!fileName) {
  //     throw new Error(this.translate.instant('message.error.file-name-cannot-be-blank'));
  //   }

  //   if (data === null || data.length === 0) {
  //     throw new Error(this.translate.instant('message.error.there-are-no-records-to-be-transferred-to-excel'));
  //   }

  //   let excelColumns = [];
  //
  //   columns.forEach(c => {
  //
  //     if (c.isExportExcel === undefined || c.isExportExcel) {
  //       excelColumns.push({
  //         header: c.header,
  //         key: c.field,
  //         width: c.excelWidth ?? ExcelConstant.DEFAULT_WIDTH,
  //         style: c.excelStyle ?? ExcelConstant.DEFAULT_STYLE,
  //         totalsRowFunction: c.totalsRowFunction
  //       });
  //     }
  //   }
  //   );
  //   this.exportExcel(data, fileName, excelColumns);

  // }

  // public exportAsExcelFile(json: any[], excelFileName: string, headersArray: any[]): void {
  //   //Excel Title, Header, Data
  //   const header = headersArray;
  //   const data = json;
  //   //Create workbook and worksheet
  //   let workbook = new Workbook();
  //   let worksheet = workbook.addWorksheet(excelFileName);
  //   //Add Header Row
  //   let headerRow = worksheet.addRow(header);
  //   // Cell Style : Fill and Border
  //   headerRow.eachCell((cell, number) => {
  //     cell.fill = {
  //       type: 'pattern',
  //       pattern: 'solid',
  //       fgColor: { argb: 'FFFFFF00' },
  //       bgColor: { argb: 'FF0000FF' }
  //     }
  //     cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  //   })
  //   // Add Data and Conditional Formatting
  //   data.forEach((element) => {
  //     let eachRow = [];
  //     headersArray.forEach((headers) => {
  //       eachRow.push(element[headers])
  //     })
  //     if (element.isDeleted === "Y") {
  //       let deletedRow = worksheet.addRow(eachRow);
  //       deletedRow.eachCell((cell, number) => {
  //         cell.font = { name: 'Calibri', family: 4, size: 11, bold: false, strike: true };
  //       })
  //     } else {
  //       worksheet.addRow(eachRow);
  //     }
  //   })
  //   worksheet.getColumn(3).width = 15;
  //   worksheet.getColumn(4).width = 20;
  //   worksheet.getColumn(5).width = 30;
  //   worksheet.getColumn(6).width = 30;
  //   worksheet.getColumn(7).width = 10;
  //   worksheet.addRow([]);
  //   //Generate Excel File with given name
  //   workbook.xlsx.writeBuffer().then((data) => {
  //     let blob = new Blob([data], { type: EXCEL_TYPE });
  //     FileSaver.saveAs(blob, excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  //   })
  // }


  public exportArrayToExcel(jsonArrayData: any[], fileName: string): void {
    if (!fileName) {
      throw new Error('Filename not found');
    }

    if (!jsonArrayData) {
      throw new Error('Data not found');
    }
    const worksheet: xlsx.WorkSheet = xlsx.utils.json_to_sheet(jsonArrayData);

    const workbook: xlsx.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });


    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, this.cleanString(fileName) + '_' + new Date().toISOString() + EXCEL_EXTENSION);
  }
  private cleanString(input) {
    var output = "";
    for (var i = 0; i < input.length; i++) {
      if (input.charCodeAt(i) <= 127) {
        output += input.charAt(i);
      }
    }
    return output;
  }

  static exportTableToExcel(fileName: string, table: ElementRef) {
    if (!fileName) {
      throw new Error('Filename not found');
    }

    if (!table) {
      throw new Error('Table not found');
    }

    const ws: xlsx.WorkSheet = xlsx.utils.table_to_sheet(table.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, fileName);

    /* save to file */
    xlsx.writeFile(wb, fileName);

  }

  static importExcelToArray(data: string): any[] {
    const workbook = xlsx.read(data, { type: 'binary' });
    const sheet_name_list = workbook.SheetNames;

    return xlsx.utils.sheet_to_json(
      workbook.Sheets[sheet_name_list[0]], { blankrows: false, defval: null, header: 1 });
  }

  public importFromFile(bstr: string): xlsx.AOA2SheetOpts {
    /* read workbook */
    const wb: xlsx.WorkBook = xlsx.read(bstr, { type: 'binary' });

    /* grab first sheet */
    const wsname: string = wb.SheetNames[0];
    const ws: xlsx.WorkSheet = wb.Sheets[wsname];

    /* save data */
    const data = <xlsx.AOA2SheetOpts>(xlsx.utils.sheet_to_json(ws, { header: 1 }));

    return data;
  }

  public getRowDataWithCols(dataList: any, columns: DynamicTableColumnModel[]) {
    let headers = dataList[0];
    return dataList.slice(1).map(rowExcel => {
      const obj = {};
      for (let i = 0; i < headers.length; i++) {
        const colHeader = headers[i];
        let colData = rowExcel[i];

        const colProperties = columns.filter(x => x.isImportExcel && (x.header == colHeader || x.field == colHeader))[0];

        let fieldName = colHeader;

        if (colProperties) {
          fieldName = colProperties.field;
        }

        if (colData == 'NULL')
          colData = null;

        if (colData != undefined) {
          if (colProperties) {
            if (colProperties.dataType == 'date') {
              obj[fieldName] = new Date((colData - 25569) * 24 * 60 * 60 * 1000);
              if (obj[fieldName] == 'Invalid Date')
                obj[fieldName] = this.getDateFromString(colData);

            }
            else {
              obj[fieldName] = colData;
            }
          } else {
            obj[fieldName] = colData;
          }

        }

      }

      return <any>obj;
    });
  }

  getDateFromString(str) {

    const [dateComponents, timeComponents] = str.split(' ');

    const [day, month, year] = dateComponents.split('.');
    const [hours, minutes, seconds] = timeComponents.split(':');

    const date = new Date(+year, +month - 1, +day, +hours, +minutes, +seconds);

    return date;
  }

  // Yardımcı metod: Excel tarih string'ini Date nesnesine çevir
  parseExcelDateString(dateStr: string): Date | null {
    // 1. "dd.MM.yyyy HH:mm:ss" formatı
    const dateTimeRegex = /^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})$/;
    const dateOnlyRegex = /^(\d{2})\.(\d{2})\.(\d{4})$/; // 2. "dd.MM.yyyy" formatı

    let match = dateStr.match(dateTimeRegex);
    if (match) {
      const [_, day, month, year, hour, minute, second] = match;
      return new Date(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10),
        parseInt(hour, 10),
        parseInt(minute, 10),
        parseInt(second, 10)
      );
    }

    match = dateStr.match(dateOnlyRegex);
    if (match) {
      const [_, day, month, year] = match;
      return new Date(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10)
      );
    }

    return null; // Hiçbir formata uymuyorsa null döndür
  }
  // Parasal ve sayısal değerleri doğru şekilde parse eden fonksiyon
  parseNumericValue(value: any): number {
    if (typeof value === "string") {
      let normalizedValue = value.replace(",", "."); // 90,00 → 90.00
      let parsedNumber = parseFloat(normalizedValue);
      let a = isNaN(parsedNumber) ? 0 : parsedNumber;

      return isNaN(parsedNumber) ? 0 : parsedNumber; // Hatalıysa 0 döndür
    }
    return Number(value) || 0;
  }
}
